// @flow
import { handleActions, type ActionType } from 'redux-actions';
import AsyncValue, { type AsyncValueType } from 'lib/async-value';
import {
  fetchClientCatalog,
  storeClientCatalog,
  selectClientCatalog,
} from './catalogActions';
import { List } from 'immutable';
import type { ClientCatalog } from './types';

export type ClientCatalogs = List<ClientCatalog>;
export type ClientCatalogState = ?AsyncValueType<ClientCatalogs>;

export type CatalogRecord = {
  +catalogs: ?AsyncValueType<ClientCatalogs>,
  +currentCatalog: ?number,
};

const defaultState: CatalogRecord = {
  catalogs: undefined,
  currentCatalog: undefined,
};

export default handleActions(
  {
    [fetchClientCatalog.toString()]: (
      state: CatalogRecord,
      action: ActionType<typeof fetchClientCatalog>
    ) => {
      return {
        ...state,
        currentCatalog: undefined,
        catalogs: AsyncValue.Pending,
      };
    },
    [storeClientCatalog.toString()]: (
      state: CatalogRecord,
      action: ActionType<typeof storeClientCatalog>
    ) => {
      return {
        ...state,
        catalogs: action.error === true ? action.payload : List(action.payload),
      };
    },
    [selectClientCatalog.toString()]: (
      state: CatalogRecord,
      action: ActionType<typeof selectClientCatalog>
    ) => {
      return {
        ...state,
        currentCatalog: action.payload,
      };
    },
  },
  defaultState
);



// WEBPACK FOOTER //
// ./src/containers/client/catalogReducer.js